var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import Chart from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { Chart as Component } from './Chart.styled';
import { getAutomation, getDebug } from '@citrus/runtime';
import { isNotNullOrEmpty, removeKeys } from '@pcty/utils';
var VERSION = '1.2.1';
var ChartBase = function (_a) {
    var _b;
    var automationId = _a.automationId, className = _a.className, css = _a.css, _c = _a.config, config = _c === void 0 ? {} : _c, data = _a.data, _d = _a.stacked, stacked = _d === void 0 ? false : _d, title = _a.title, xAxis = _a.xAxis, yAxis = _a.yAxis, _e = _a.thousandsSep, thousandsSep = _e === void 0 ? ',' : _e, TYPE = _a.__TYPE, other = __rest(_a, ["automationId", "className", "css", "config", "data", "stacked", "title", "xAxis", "yAxis", "thousandsSep", "__TYPE"]);
    stacked = ['BarChart', 'ColumnChart'].indexOf(TYPE) >= 0 ? stacked : false;
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    Highcharts.setOptions({
        lang: {
            thousandsSep: thousandsSep,
        },
    });
    return (React.createElement(Component, __assign({ className: classes }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)),
        React.createElement(Chart, { highcharts: Highcharts, options: getConfig(title, data, stacked, xAxis, yAxis, TYPE, config) })));
};
var colors = new Map([
    ['blue', '#41A8D2'],
    ['yellow', '#FFD70B'],
    ['green', '#3DC270'],
    ['red', '#D43046'],
    ['purple', '#5E4982'],
    ['orange', '#FF8800'],
    ['orange-light', '#F8B100'],
    ['blue-dark', '#11779C'],
    ['green-light', '#53D168'],
    ['lime', '#D1EB58'],
    ['purple-light', '#A95998'],
    ['pink', '#F59299'],
]);
var getConfig = function (title, data, stacked, xAxis, yAxis, type, customConfig) { return (__assign(__assign(__assign(__assign(__assign({}, chartConfig), { chart: {
        type: type === 'DonutChart' ? 'pie' : type.split(/(?=[A-Z])/)[0].toLowerCase(),
    }, colors: data.map(function (x, index) {
        return colors.get(x.color) ||
            chartConfig.colors[index >= chartConfig.colors.length ? index % chartConfig.colors.length : index];
    }) }), (stacked
    ? {
        plotOptions: {
            series: {
                stacking: 'normal',
            },
        },
    }
    : {})), { series: type === 'DonutChart'
        ? [
            __assign(__assign({}, chartConfig.series[0]), { data: data.map(function (x) { return removeKeys(__assign(__assign({}, x), { y: x.value }), ['color', 'value']); }) }),
        ]
        : data.map(function (x) { return removeKeys(__assign(__assign({}, x), { data: x.series }), ['color', 'series', 'value']); }), title: {
        text: title,
    }, xAxis: xAxis, yAxis: yAxis }), customConfig)); };
var chartConfig = {
    credits: {
        enabled: false,
    },
    exporting: {
        enabled: false,
    },
    legend: {
        reversed: false,
        symbolRadius: '2px',
        symbolHeight: 16,
        symbolPadding: 8,
        padding: 16,
        itemDistance: 32,
        itemMarginTop: 8,
        itemStyle: {
            fontSize: '14px',
            fontWeight: 'normal',
        },
    },
    colors: Array.from(colors.keys()).map(function (x) { return colors.get(x); }),
    style: {
        fontFamily: 'Open Sans',
    },
    plotOptions: {
        area: {
            marker: {
                enabled: true,
                symbol: 'circle',
            },
        },
        line: {
            marker: {
                enabled: true,
                symbol: 'circle',
            },
        },
    },
    series: [
        {
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            dataLabels: {
                enabled: true,
            },
        },
    ],
};
export default ChartBase;
